define('viewModels/privileged/qm/policies/editors/DateRangeEditorView',[
    'lib/knockout',
    'moment',
    'util/dateTimeConstant',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n'
], function (ko, moment, dateTimeConstant, ViewModel) {
    'use strict';

    /**
     * The DateRangeEditorView class.
     * @class
     */
    var DateRangeEditorView = ViewModel.extend(function (dateRangeObservable) {

        var self = this;
        var startDate = ko.observable();
        var endDate = ko.observable();

        var dateRanges = dateRangeObservable;

        self.dateRangeText = ko.observable();
        self.isOpen = ko.observable(false);
        self.dateRangeValue = ko.observableArray();
        self.dateTimeRangeValue = ko.observableArray();
        self.placeHolderText = ko.observable();

        var updateDateRangeValues = function(dateRangeValue) {
            dateRanges([dateRangeValue]);
            var dates = dateRanges()[0].split('/');
            if(dates.length === 2) {
                startDate(moment(dates[0]).format(dateTimeConstant.ShortDate));
                endDate(moment(dates[1]).format(dateTimeConstant.ShortDate));
            }
            var dateRangeText = ko.i18n.renderString('widget.dateRangePicker.intervalFormat', {
                startDate: startDate(),
                endDate: endDate()
            });
            self.dateRangeText(dateRangeText);
        };
        /**
         *  If the user saved a date range previously then the logic below will populate the grid
         *  with that range. If the user just selected the date range filter then the date range will
         *  be the start of today to the end of today.
         */
        if (dateRanges() && dateRanges().length > 0) {
            // TODO: Support more than 1 daterange
            var dateRange = dateRanges()[0];
            var dates = dateRange.split('/');
            if (dates.length === 2) {
                startDate(dates[0]);
                endDate(dates[1]);
            }
            self.dateRangeValue(startDate() + '/' + endDate());
        } else {
            var todayStart = moment().startOf('day').toDate();
            var todayEnd = moment().endOf('day').toDate();
            self.dateRangeValue(todayStart.toISOString() + '/' + todayEnd.toISOString());
        }

        /**
         * dateRangeValue is being updated via the daterangepicker binding handler
         * in most cases the canned ranges will be updating this value upon click
         * in other cases this value will be updated when the user selects the custom range option and
         * selects a range from the two calendars.
         */
        self.computed(function () {
            updateDateRangeValues(self.dateRangeValue());
        });
    });

    return DateRangeEditorView;
});

